// TODO: Create lokalise keys
export enum LOGIN {
    GO_BACK_TO_LOGIN = 'Go back to the login',
}
